




















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { emptyToLine } from "@/utils/common";
import dayjs from "dayjs";
import router from "@/router";
const store = namespace("store");
const user = namespace("user");
@Component({})
export default class StoreInfo extends Vue {
  @store.Action getStoreInfo;
  @user.State selectedOrgCode;
  emptyToLine = emptyToLine;
  dayjs = dayjs;
  repeatValueList: any = [];
  storeData: any = {};
  dateTime: any = ""; //营业时间
  timeId: any = "";
  // loading:boolean= true
  get name() {
    return (this.storeData.managerFirstName || "") + (this.storeData.managerLastName || "");
  }
  get address() {
    return (
      (this.storeData.stateName || "") +
      (this.storeData.cityName || "") +
      (this.storeData.districtName || "") +
      (this.storeData.address1 || "")
    );
  }

  // @Watch('$route',{immediate:true})
  // onRouteChange(val) {
  //   if(val.path === "/setting/store"){
  //     created()
  //   }
  // }

  handleLinkEdit() {
    this.$router.push("/setting/storeEdit");
  }

  async created() {
    // this.timeId = setTimeout(async ()=>{
    let { data } = await this.getStoreInfo({
      orgCode: this.selectedOrgCode
    });
    this.storeData = data;
    this.dateTime = this.storeData.repeatValue;

    if (this.$route.query.date === undefined) {
      this.repeatValueList = JSON.parse(this.dateTime);
    } else {
      this.repeatValueList = JSON.parse((this.$route.query as any).date);
    }
    // this.loading = false
    // },500)
  }

  beforeDestroy() {
    window.clearTimeout(this.timeId);
    this.timeId = null;
  }
}
